export default function getViewportHeight() {
  var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
  var documentHeight;
  try {
    documentHeight = document.documentElement.clientHeight || 0;
  } catch (e) {
    documentHeight = 0;
  }
  return Math.max(documentHeight, window.innerHeight || 0);
}